import { render, staticRenderFns } from "./orderQuery.vue?vue&type=template&id=63d6b628&scoped=true&"
import script from "./orderQuery.vue?vue&type=script&lang=js&"
export * from "./orderQuery.vue?vue&type=script&lang=js&"
import style0 from "./orderQuery.vue?vue&type=style&index=0&id=63d6b628&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63d6b628",
  null
  
)

export default component.exports